import React from 'react';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import useDebugInformation from '../../hooks/useDebugInformation';
import { temp, ui } from '../../interfaces/interfaces';
import { ContactPrefix } from '../../utilities/BasicTypes';
import ContactUtils from '../../utilities/contact';
import { useAppSelector } from "@store/hooks";

const name = "ContactButtonBR"

const getProblemContactsLength = (prefix: Props["prefix"]) => {
    const mergedContacts = ContactUtils.mergeContacts({ prefix, temp, ui })
    return mergedContacts.length
}

type Props = {
    tooltip: string;
    prefix: ContactPrefix,
    parent: string;
    disabledBtn: boolean
}

const ContactButtonBR: React.FC<Props> = ({ tooltip, prefix, parent, disabledBtn }) => {
    const contactFormValid = useAppSelector(({ state }) => state[`${prefix}Valid`])
    const [length, setLength] = React.useState(getProblemContactsLength(prefix))
    React.useEffect(() => setLength(getProblemContactsLength(prefix)), [prefix, contactFormValid])
    const debugName = `${parent}▷[${name}]`

    const showModal = React.useCallback(() => ContactUtils.showContactModal({ ui, prefix }), [prefix])

    useDebugInformation(debugName, { tooltip, prefix, parent, disabledBtn, contactFormValid, length })
    return (
        <Tooltip title={tooltip ? tooltip : "Contact"}>
            <span>
                <IconButton onClick={showModal} hidden={length > 0 ? false : true} disabled={disabledBtn ? disabledBtn : false}>
                    <Badge badgeContent={length ? length : 0} color="primary" invisible={disabledBtn ? disabledBtn : false} >
                        <ContactPageIcon color={disabledBtn ? "disabled" : "action"} />
                    </Badge>
                </IconButton>
            </span>
        </Tooltip>
    )
}

export default React.memo(ContactButtonBR)
